import { isTMA } from './is-tma';
import { showPopup } from './show-popup';

/**
 * Displays a confirmation message and resolves a promise based on user input.
 */
export const confirmAction = (data: {
  title?: string;
  message: string;
  agree: string;
  cancel: string;
}) => {
  return new Promise<boolean>((resolve) => {
    if (isTMA()) {
      showPopup(
        {
          title: data?.title,
          message: data.message,
          buttons: [
            { id: 'cancel', type: 'cancel' },
            { id: 'disable', type: 'destructive', text: data.agree },
          ],
        },
        (buttonId) => {
          resolve(buttonId === 'disable');
        }
      );
    } else if (confirm(data.message)) {
      resolve(true);
    } else {
      resolve(false);
    }
  });
};
